export const shouldRenderErxAnnouncement = (url: string): boolean => {
  // Dirty way to check if the link is the needed one
  return url.includes('/rezept-einloesen')
}
